import { Instance, types } from 'mobx-state-tree';

export const EnrollmentOrderItem = types.model('EnrollmentOrderItem', {
  description: types.maybe(types.string),
  howToUse: types.maybe(types.string),
  imageUrl: types.maybe(types.string),
  inStock: types.boolean,
  isPromotional: types.boolean,
  largeImageUrl: types.maybe(types.string),
  legacyId: types.identifierNumber,
  name: types.maybe(types.string),
  partNumber: types.maybe(types.string),
  pointValue: types.number,
  priceWithTax: types.number,
  shortDescription: types.maybe(types.string),
  storeId: types.number,
  quantity: types.number,
  priceWithTaxTotal: types.number
});

export type EnrollmentOrderItem = Instance<typeof EnrollmentOrderItem>;
